import {connect, useSelector} from "react-redux";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import dayjs from "dayjs";
import * as formatter from "../../../../config/formatter";
import * as o2Api from "../../../../api/api";
import {Loading} from "../../../../components/common";
import {CAlert, CButton, CCol, CForm, CFormInput, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";
import {DatePicker} from "antd";
import locale from "antd/es/date-picker/locale/ko_KR";
import {AgGridReact} from "ag-grid-react";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";
import {deleteSaleData, getDailySales} from "../../../../api/api";
import sha256 from "sha256";

const {RangePicker} = DatePicker;
const DeleteSaleData = (props) => {
	const {user} = useSelector((props) => props.account);
	const gridRef = useRef();
	const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
	const [saleRowData, setSaleRowData] = useState([]);
	const [detailRowData, setDetailRowData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState({visible: false, message: ""});
	const [delPassword, setDelPassword] = useState("");
	const [searchForm, setSearchForm] = useState({
		cmpCd: "", brandCd: "", storeCd: "", cornerCd: "",
		fromSaleDt: dayjs().add(-1, "d"), toSaleDt: dayjs().add(-1, "d")
	});

	const defaultColDef = {
		width: 100,
		resizable: true,
		sortable: true,
		filter: false,
		autoHeaderHeight: true
	};

	const [saleColumnDefs] = useState([
		{field: "cmpCd", headerName: "회원사코드", hide: true},
		{field: "brandCd", headerName: "브랜드코드", hide: true},
		{field: "storeCd", headerName: "매장코드", hide: true},
		{
			field: "statTime", headerName: "일자",
			valueFormatter: (e) => {
				return formatter.timeFormatter(e, "YYYYMMDD", "YYYY-MM-DD")
			},
			minWidth: 100, cellClass: "static-cell"
		},
		{
			field: "saleQty",
			headerName: "건수",
			maxWidth: 60,
			valueFormatter: formatter.currencyFormatter,
			cellClass: "number-cell"
		},
		{field: "cashAmt", headerName: "현금결제", minWidth: 100, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "cardAmt", headerName: "카드결제", minWidth: 100, valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
	]);

	const [detailColumnDefs] = useState([
		{field: "cmpCd", headerName: "회원사코드", hide: true},
		{field: "brandCd", headerName: "브랜드코드", hide: true},
		{field: "storeCd", headerName: "매장코드", hide: true},
		{
			field: "check",
			headerName: "",
			width: 50,
			headerCheckboxSelection: true,
			checkboxSelection: true,
			showDisabledCheckboxes: true
		},
		{
			field: "saleDt", headerName: "일자", valueFormatter: (e) => {
				return formatter.timeFormatter(e, "YYYYMMDD", "YYYY-MM-DD")
			}, cellClass: "static-cell"
		},
		{field: "posCd", headerName: "POS", width: 60, cellClass: "static-cell"},
		{field: "billNo", headerName: "영수증", cellClass: "static-cell"},
		{
			field: "saleTime", headerName: "결제시간", valueFormatter: (e) => {
				return formatter.timeFormatter(e, "YYYYMMDDHHmmss", "HH시 mm분 ss초")
			}, cellClass: "static-cell"
		},
		{field: "tradeTypeNm", headerName: "구분", width: 60, cellClass: "static-cell"},
		{field: "saleAmt", headerName: "총매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "dcAmt", headerName: "총할인액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
		{field: "payAmt", headerName: "실매출액", valueFormatter: formatter.currencyFormatter, cellClass: "number-cell"},
	]);

	useEffect(() => {

	}, []);

	const handleSelect = (code, value) => {
		if (value === "C") {
			setSearchForm((state) => ({
				...state,
				cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
			}));
		} else if (value === "B") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: code, storeCd: "", cornerCd: ""
			}));
		} else if (value === "S") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: code, cornerCd: ""
			}));
		} else if (value === "O") {
			setSearchForm((state) => ({
				...state,
				cmpCd: state.cmpCd, brandCd: state.brandCd, storeCd: state.storeCd, cornerCd: code
			}));
		}
	};

	const search = () => {
		setError({visible: false, message: ""});

		setSaleRowData([]);
		setDetailRowData([]);

		const {cmpCd, brandCd, storeCd} = searchForm;

		if (brandCd === undefined || brandCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 휴게소는 반드시 선택하셔야 합니다."
			});
			return;
		}

		if (storeCd === undefined || storeCd.length === 0) {
			setError({
				visible: true,
				message: "조회시 매장은 반드시 선택하셔야 합니다."
			});
			return;
		}

		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			fromSaleDt: searchForm.fromSaleDt.format("YYYYMMDD"),
			toSaleDt: searchForm.toSaleDt.format("YYYYMMDD")
		};

		setLoading(true);
		o2Api.getDailySales(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			console.log("result : ", responseBody);

			if (responseCode === "200") {
				// 성공
				setSaleRowData(responseBody);
				setLoading(false);
			}
		});
	};

	const onDetail = (data) => {
		setError({visible: false, message: ""});
		const {saleDt, cmpCd, brandCd, storeCd} = data;

		console.log(">>>> data :: ", data);

		const params = {
			cmpCd: cmpCd,
			brandCd: brandCd,
			storeCd: storeCd,
			saleDt: data.statTime
		};

		console.log(">>> params :: ", params);
		setLoading(true);
		o2Api.getCurrentDay(params).then((result) => {
			const {responseBody, responseCode, responseMessage} = result.data;
			console.log("result : ", responseBody);

			if (responseCode === "200") {
				// 성공
				setDetailRowData(responseBody);
				setLoading(false);

				createFooterData(responseBody);
			}
		});
	}

	const sum = (values, col) => {
		let sum = 0;
		values.forEach((value) => {
			sum += value[col]
		})
		return sum;
	}

	const createFooterData = (data) => {
		const api = gridRef.current.api;
		const result = [];
		result.push({
			posCd: "합계",
			saleTime: null,
			saleQty: sum(data, 'saleQty'),
			saleAmt: sum(data, 'saleAmt'),
			dcAmt: sum(data, 'dcAmt'),
			payAmt: sum(data, 'payAmt'),
			netAmt: sum(data, 'netAmt'),
			payAmtVat: sum(data, 'payAmtVat'),
			totalPayAmt: sum(data, 'totalPayAmt'),
			cashAmt: sum(data, 'cashAmt'),
			cardAmt: sum(data, 'cardAmt')

		});
		api.setPinnedBottomRowData(result);
	};

	const [totalRowData] = useState([
		{saleDt: "합계", saleTime: null, saleQty: 0, saleAmt: 0, dcAmt: 0, payAmt: 0, netAmt: 0, vatAmt: 0, bagPrice: 0}
	])

	const onRowSelected = useCallback((e) => {
		if (!e.node.selected) return;
		onDetail(e.node.data);
	}, [])

	const onDelete = () => {
		// 비밀번호 체크
		if (delPassword.length === 0) {
			alert("삭제 패스워드를 입력해주세요.");
			return;
		}

		if (sha256(delPassword) !== user.password) {
			alert("삭제 패스워드가 일치하지 않습니다. 다시 입력해주세요.");
			return;
		}

		const {api} = gridRef.current;
		if (api === null) return;

		const selectRows = api.getSelectedRows();
		if (selectRows.length > 0) {
			if (confirm("선택하신 매출자료를 삭제하시겠습니까?\n삭제 후 복구가 불가능합니다.")) {
				const params = [];
				selectRows.map((item) => {
					params.push(item.seq);
				});

				setLoading(true);
				console.log(">>> params :: ", params);
				deleteSaleData(params).then((result) => {
					const {responseBody, responseCode, responseMessage} = result.data;
					console.log(">>> result.data :: ", result.data);
					if (responseCode === "200") {
						setLoading(false);
						alert("처리가 완료되었습니다.");
						search();
					}
				})
					.catch((e) => {
						setLoading(false);
						alert("삭제 과정 중 오류가 발생했습니다.\n" + e.message);
					})
			}
		}
	}

	return (
		<div style={containerStyle}>
			{loading ? <Loading/> : null}
			{error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
			<div className="d-md-flex align-items-center justify-content-between p-1">
				<h5>매출자료 삭제</h5>
			</div>

			<StoreCornerListWhere type={"S"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
			<div className={"row row-cols-lg-auto g-1 m-0 align-items-center"}>
				<CCol sm={12}>
					<CInputGroup size={"sm"}>
						<CInputGroupText style={{width: 80}}>조회일자</CInputGroupText>
						<CInputGroupText style={{background: "white", height: 35}}>
							<RangePicker bordered={false}
										 separator={"~"}
										 placeholder={""}
										 locale={locale}
										 value={[searchForm.fromSaleDt, searchForm.toSaleDt]}
										 onChange={(dayjs, dateString) => {
											 setSearchForm((state) => ({
												 ...state, fromSaleDt: dayjs[0], toSaleDt: dayjs[1]
											 }));
										 }}/>
						</CInputGroupText>
					</CInputGroup>
				</CCol>
				<CCol sm={12}>
					<CInputGroup size={"sm"} style={{height: 35}}>
						<CInputGroupText style={{width: 100}}>삭제패스워드</CInputGroupText>
						<CFormInput id="password"
									type="password"
									onChange={(e) => {
										setDelPassword(e.target.value)
									}}/>
					</CInputGroup>
				</CCol>
				<div className={"d-grid d-md-flex gap-1"}>
					<CButton style={{minWidth: 50, height: 35}} size={"sm"} color={"primary"} onClick={search}>조회</CButton>
				</div>
			</div>
			<div style={{height: 10}}/>
			<h6><span style={{color: "red"}}>*</span>삭제시 패스워드를 정확히 입력하여 주십시오.</h6>
			<h6><span style={{color: "red"}}>*</span>당일 매출은 처리할 수 없습니다. 매출 삭제 처리시 해당 일자의 집계 데이터가 재생성되며, 시간이 소요될 수 있습니다.
			</h6>
			<div className={"row"}>
				<div className={"col-lg-4"}>
					<div className={"d-flex mt-1 align-items-center"} style={{padding: 5, height: 40, background: "#87CEFA"}}>
						<span><strong>일자별 매출</strong></span>
					</div>
					<div className="ag-theme-alpine" style={{width: "100%"}}>
						<AgGridReact
							rowSelection={"single"}
							domLayout={"autoHeight"}
							headerHeight={30}
							rowHeight={30}
							rowData={saleRowData}
							animateRows={true}
							enableRangeSelection={true}
							enableCellTextSelection={true}
							suppressClipboardPaste={true}
							localeText={{noRowsToShow: "조회 결과가 없습니다."}}
							onRowSelected={onRowSelected}
							defaultColDef={defaultColDef}
							columnDefs={saleColumnDefs}>
						</AgGridReact>
					</div>
				</div>
				<div className={"col-lg-8"}>
					<div className="d-flex mt-1 align-items-center justify-content-between" style={{padding: 5, height: 40, background: "#87CEFA"}}>
						<span><strong>매출상세</strong></span>
						<CButton size={"sm"} color="dark" onClick={onDelete}>삭제</CButton>
					</div>
					<div className="ag-theme-alpine" style={{width: "100%", height: 500}}>
						<AgGridReact
							ref={gridRef}
							rowSelection={"multiple"}
							headerHeight={30}
							rowHeight={30}
							rowData={detailRowData}
							animateRows={true}
							enableRangeSelection={true}
							enableCellTextSelection={true}
							suppressClipboardPaste={true}
							localeText={{noRowsToShow: "조회 결과가 없습니다."}}
							pinnedBottomRowData={totalRowData}
							defaultColDef={defaultColDef}
							columnDefs={detailColumnDefs}>
						</AgGridReact>
					</div>
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	const {account, store, selected} = state;
	return {
		account, store, selected
	};
};

export default connect(mapStateToProps, null)(DeleteSaleData);
